<template>
    <el-card style="height: 710px;overflow-y: scroll;">
        <div class="region">
            <p style="margin-bottom: 10px;">平台更新公告管理</p>

            <el-button type="primary" class="add_button" @click="dialogVisible = true">新增通告</el-button>
            <el-table border :data="tableData" :header-cell-style="{ 'background-color': '#f6f6f6' }"
                style="width: 100%;margin-top: 20px;">
                <el-table-column align="center" type="index" width="80px" label="序号"></el-table-column>
                <el-table-column align="center" prop="title" width="150px" label="版本"></el-table-column>
                <el-table-column align="center" prop="content" show-overflow-tooltip label="内容"></el-table-column>
                <el-table-column align="center" prop="create_time" width="200px" label="创建时间"></el-table-column>

                <el-table-column align="center" prop="address" label="操作">
                    <template slot-scope="scope">
                        <el-button @click="detialRegionShow(scope.row)" type="text" class="button">详情</el-button>
                        <!-- <el-button @click="deleteRegion(scope.row.id)" type="text" class="button">删除</el-button> -->
                    </template>
                </el-table-column>
            </el-table>

            <el-pagination background :current-page="current_page" layout="prev, pager, next" :page-size="pageSize"
                hide-on-single-page @current-change="changePage" @prev-click="changePage" @next-click="changePage"
                :total="total">
            </el-pagination>

            <el-dialog :modal="false" class="dialog" title="新增通告" :visible.sync="dialogVisible" :show-close="false"
                @close="closeDialog" width="30%">
                <el-form :model="form" :rules="rules" ref="ruleForm">
                    <el-form-item label="版本" prop="title">
                        <el-input placeholder="请输入" style="width: 80%" v-model="form.title"></el-input>
                    </el-form-item>
                    <el-form-item label="内容" prop="content">
                        <el-input type="textarea" :rows="9" placeholder="请输入" style="width: 80%;height: 200px;"
                            v-model="form.content"></el-input>
                    </el-form-item>

                </el-form>
                <el-row class="buttons" type="flex" align="middle" justify="end" style="margin-right: 30px;">
                    <el-button @click="dialogVisible = false">取消</el-button>
                    <el-button type="primary" @click="submitRegionForm">确定</el-button>
                </el-row>
            </el-dialog>

            <el-dialog :modal="false" class="dialog" title="通告详情" :visible.sync="dialogVisibleDetail" :show-close="false"
                @close="closeDialog" width="30%">
                <div>
                    <div>版本：{{selectNotice.title}}</div>
                    <div>内容：{{selectNotice.content}}</div>
                    <div>创建时间：{{selectNotice.create_time}}</div>
                </div>
                <el-row class="buttons" type="flex" align="middle" justify="end" style="margin-right: 30px;">
                    <!-- <el-button @click="dialogVisible = false">取消</el-button> -->
                    <el-button type="primary" @click="dialogVisibleDetail = false">确定</el-button>
                </el-row>
            </el-dialog>
        </div>
    </el-card>
</template>

<script>
import axios from 'axios';
import { get_update_notice, add_update_notice,put_update_notice } from '@/api/UpdateNotice';

export default {
    name: 'UpdateNoticeView',

    data() {
        return {
            current_page: 1,
            pageSize: 10,
            total: 0,
            page: 1,
            dialogVisible: false,
            dialogVisibleDetail: false,
            tableData: [
                { title: '更新公告1', content: '内容1', create_time: '2023-07-01' },
                { title: '更新公告2', content: '内容2', create_time: '2023-07-02' },
                { title: '更新公告3', content: '内容3', create_time: '2023-07-03' },
                { title: '更新公告4', content: '内容4', create_time: '2023-07-04' },
                { title: '更新公告5', content: '内容5', create_time: '2023-07-05' },
            ],
            selectNotice:[],
            form: {
                title: '',
                content: '',
            },
            rules: {
                title: [
                    { required: true, message: '请输入标题', trigger: 'blur' },
                ],
                content: [
                    { required: true, message: '请输入内容', trigger: 'blur' },
                ],
            },
        };
    },

    mounted() {
        this.getUpdateNoticeList();
    },

    methods: {
        getUpdateNoticeList() {
            get_update_notice(this.current_page, this.pageSize)
                .then(res => {
                    const { data } = res;
                    if (data.code === 200) {
                        this.tableData = data.data;
                        this.total = data.count;
                    } else {
                        this.$message.error('获取更新公告失败');
                    }
                })
                .catch(error => {
                    console.error('获取更新公告失败:', error);
                });
        },
        closeDialog() {
            this.dialogVisible = false;
            this.form = {
                title: '',
                content: '',
            };
        },
        detialRegionShow(row) {
            this.dialogVisibleDetail = true;
            this.selectNotice = row;
            this.form.title = row.title;
            this.form.content = row.content;
        },
        submitRegionForm() {
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    add_update_notice(this.form)
                        .then(res => {
                            const { data } = res;
                            if (data.code === 200) {
                                this.$message.success('新增通告成功');
                                this.dialogVisible = false;
                                this.form = {
                                    title: '',
                                    content: '',
                                };
                                this.page = 1;
                                localStorage.setItem('app_version', this.form.title);
                                this.getUpdateNoticeList();
                            } else {
                                this.$message.error('新增通告失败');
                            }
                        })
                } else {
                    this.$message.error('请填写完整信息');
                }
            });
        },
        changePage(page) {
            this.current_page = page;
            this.getUpdateNoticeList();
        },
    },
};
</script>